import { put, call, select, takeLatest } from 'redux-saga/effects';
import {
  setEmptyTouristsAction,
  setTouristValidatedAction,
  validateTouristOnServerAction,
} from 'src/routes/Checkout/store/actions/tourists';
import { VALIDATE_TOURIST_DATA } from 'src/routes/Checkout/store/constants/tourists';
import { selectFlight } from 'src/routes/Checkout/store/reducers/order';
import { validateTouristBySchema } from 'src/routes/Checkout/store/sagas/tourists';
import {
  touristValidationFailedAction,
  touristValidationSuccessAction,
} from 'src/routes/Checkout/store/validation/actions';
import { touristSelector } from 'src/store/tourists/selectors';

function* handleTouristValidation(action) {
  const { payload: index } = action;
  const touristInfo = yield select(touristSelector, index);
  try {
    yield call(validateTouristBySchema, touristInfo);
    yield put(validateTouristOnServerAction(index));
    yield put(setTouristValidatedAction(index));
    yield put(touristValidationSuccessAction({ index, touristInfo }));
  } catch (err) {
    // @ts-ignore
    yield put(touristValidationFailedAction({ errors: err.inner, index }));
  }
}

function* handleSetEmptyTourists() {
  yield put(setEmptyTouristsAction());
}

export default function* touristSaga() {
  yield takeLatest(VALIDATE_TOURIST_DATA, handleTouristValidation);
  yield takeLatest(selectFlight.type, handleSetEmptyTourists);
}
